import React from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';

const CookieBanner = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    padding: 20px;
    background-color: var(--white);
    border-top: 1px solid var(--gray);
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }

    ${mqMin('NARROW')} {
        padding: 24px;
    }
`;

const BannerContent = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${mqMin('NARROW')} {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
`;

const TextContent = styled.div`
    flex: 1;

    ${mqMin('NARROW')} {
        margin-right: 24px;
    }
`;

const Text = styled.p`
    font-size: var(--font-default);
    margin: 0;
    line-height: 1.5;
`;

const Link = styled.a`
    color: var(--main-color-blue);
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    ${mqMin('NARROW')} {
        flex-direction: row;
        align-items: center;
        min-width: 260px;
    }
`;

const Button = styled.button<{ variant: 'outlined' | 'contained' }>`
    min-width: 120px;
    padding: 8px 16px;
    border: 1px solid ${(props) => (props.variant === 'outlined' ? 'var(--main-color-blue)' : 'transparent')};
    border-radius: 4px;
    background-color: ${(props) => (props.variant === 'contained' ? 'var(--main-color-blue)' : 'transparent')};
    color: ${(props) => (props.variant === 'contained' ? 'var(--white)' : 'var(--main-color-blue)')};
    font-size: var(--font-default);
    font-weight: var(--font-bold);
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.8;
    }

    ${mqMin('NARROW')} {
        width: 120px;
    }
`;

interface CookieConsentProps {
    onAccept: () => void;
    onDecline: () => void;
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onDecline }) => {
    return (
        <CookieBanner>
            <BannerContent>
                <TextContent>
                    <Text>
                        このサイトでは、ユーザーエクスペリエンスの向上、サイトの分析、広告配信のためにCookieを使用しています。
                        詳細については、当社の{' '}
                        <Link href="/privacy/" target="_blank" rel="noopener noreferrer">
                            プライバシーポリシー
                        </Link>
                        をご確認ください。
                    </Text>
                </TextContent>
                <ButtonGroup>
                    <Button variant="outlined" onClick={onDecline}>
                        拒否
                    </Button>
                    <Button variant="contained" onClick={onAccept}>
                        同意
                    </Button>
                </ButtonGroup>
            </BannerContent>
        </CookieBanner>
    );
};
